import { uploadFilesGetLinks, uploadSingleFile } from "../files";
import { API, authClient } from "../index";

export const postArtwork = async (artwork, image) => {
  if (artwork?.imagesURLs?.length > 0) {
    for (let i = 0; i < artwork.imagesURLs.length; i++) {
      const image = artwork.imagesURLs[i];
      if (typeof image.url !== "string") {
        let imageURL = await uploadSingleFile(image.url, "artworks");
        artwork.imagesURLs[i] = {
          url: imageURL?.data?.fileURL?.replace(/\\/g, "/"),
          order: image.order,
        };
      }
    }
  }
  if (artwork?.videosURLs?.length > 0) {
    for (let i = 0; i < artwork.videosURLs.length; i++) {
      const video = artwork.videosURLs[i];
      if (typeof video.url !== "string") {
        let videoURL = await uploadSingleFile(video.url, "artworks");
        artwork.videosURLs[i] = {
          url: videoURL?.data?.fileURL?.replace(/\\/g, "/"),
          order: video.order,
        };
      }
    }
  }
  if (artwork?.filesURLs?.length > 0) {
    for (let i = 0; i < artwork.filesURLs.length; i++) {
      const file = artwork.filesURLs[i];
      if (typeof file.url !== "string") {
        let fileURL = await uploadSingleFile(file.url, "artworks");
        artwork.filesURLs[i] = {
          url: fileURL?.data?.fileURL?.replace(/\\/g, "/"),
          order: file.order,
        };
      }
    }
  }
  if (image) {
    const response = await uploadSingleFile(image, "artworks");
    artwork.imageURL = response?.data?.fileURL;
  }
  for (const artworkSupplier of artwork?.artworkSuppliers) {
    if (artworkSupplier.images && artworkSupplier.images?.length) {
      let imagesURLs = await uploadFilesGetLinks(
        artworkSupplier.images,
        "artworkSuppliers"
      );
      artworkSupplier.imagesURLs = imagesURLs;
    }
    if (artworkSupplier.files && artworkSupplier.files?.length) {
      let filesURLs = await uploadFilesGetLinks(
        artworkSupplier.files,
        "artworkSuppliers"
      );
      artworkSupplier.filesURLs = filesURLs;
    }
  }
  return authClient().post(`${API}/artwork`, artwork);
};

export const getArtworks = (imageURL, getDeleted) => {
  return authClient().get(
    `${API}/artwork?${
      imageURL ? `imageURL=${imageURL}` : ""
    }&getDeleted=${getDeleted}`
  );
};

export const getArtworkById = (id) => {
  return authClient().get(`${API}/artwork/${id}`);
};

export const updateArtwork = async (id, artwork, image) => {
  if (artwork?.imagesURLs?.length > 0) {
    for (let i = 0; i < artwork.imagesURLs.length; i++) {
      const image = artwork.imagesURLs[i];
      if (typeof image.url !== "string") {
        let imageURL = await uploadSingleFile(image.url, "artworks");
        artwork.imagesURLs[i] = {
          url: imageURL?.data?.fileURL?.replace(/\\/g, "/"),
          order: image.order,
        };
      }
    }
  }
  if (artwork?.videosURLs?.length > 0) {
    for (let i = 0; i < artwork.videosURLs.length; i++) {
      const video = artwork.videosURLs[i];
      if (typeof video.url !== "string") {
        let videoURL = await uploadSingleFile(video.url, "artworks");
        artwork.videosURLs[i] = {
          url: videoURL?.data?.fileURL?.replace(/\\/g, "/"),
          order: video.order,
        };
      }
    }
  }
  if (artwork?.filesURLs?.length > 0) {
    for (let i = 0; i < artwork.filesURLs.length; i++) {
      const file = artwork.filesURLs[i];
      if (typeof file.url !== "string") {
        let fileURL = await uploadSingleFile(file.url, "artworks");
        artwork.filesURLs[i] = {
          url: fileURL?.data?.fileURL?.replace(/\\/g, "/"),
          order: file.order,
        };
      }
    }
  }
  if (image) {
    const response = await uploadSingleFile(image, "artworks");
    artwork.imageURL = response?.data?.fileURL;
  }
  for (const artworkSupplier of artwork?.artworkSuppliers) {
    if (artworkSupplier.images && artworkSupplier.images?.length) {
      let imagesURLs = await uploadFilesGetLinks(
        artworkSupplier.images,
        "artworkSuppliers"
      );

      artworkSupplier.imagesURLs = (artworkSupplier.imagesURLs || []).concat(
        imagesURLs
      );
    }
    if (artworkSupplier.files && artworkSupplier.files?.length) {
      let filesURLs = await uploadFilesGetLinks(
        artworkSupplier.files,
        "artworkSuppliers"
      );

      artworkSupplier.filesURLs = (artworkSupplier.filesURLs || []).concat(
        filesURLs
      );
    }
  }
  return authClient().put(`${API}/artwork/${id}`, artwork);
};

export const changeStatusArtwork = async (id, deleted) => {
  return authClient().put(`${API}/artwork/change-status/${id}`, { deleted });
};

export const changeSupplierArtwork = async (id, idOwner) => {
  return authClient().put(`${API}/artwork/change-supplier/${id}`, { idOwner });
};

export const deleteArtwork = (id) => {
  return authClient().delete(`${API}/artwork/${id}`);
};
